module.exports = __webpack_public_path__ + "static/media/logo-conlicitacao-colorido.009684df.svg";